import React from 'react'
import { PanelGroup, PanelGroupProps } from 'react-resizable-panels'

export const ResizablePanelGroup = (props: PanelGroupProps) => {
	return <PanelGroup {...props}>{props.children}</PanelGroup>
}
